export const L10N = {
  ACTION_VIEW_MORE: { id: 'common.action.view_more' },
  LABEL_PER_NIGHT: { id: 'core.label.per_night' },
  NOTIFICATION_ERROR_MAP: { id: 'core.notification.error_map' },
};
